module.exports = __webpack_public_path__ + "img/error.927de205.svg";